import { FilterResults } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { ActiveFilterOptions } from '@terminal/components/filters/Filters';
import { mapFilters } from '@terminal/views/screener/use-screener-store/filter-utils';

import { fetchFilteredEntities } from '../use-screener-entities-tags/entity-screener-service/entity-screener-service';
import { hasUsableScreenerFilters } from '../use-screener-entities-tags/entity-screener-service/utils';

export const QUERY_KEY_SCREENER_ENTITIES = 'QUERY_KEY_SCREENER_ENTITIES';

export const getScreenerEntitiesQueryConfig = ({
  filterOptions,
  defaultOptionsMapped = {},
}: {
  filterOptions: ActiveFilterOptions[];
  defaultOptionsMapped?: Record<
    string,
    {
      values: Record<string, unknown>[];
      children?: Record<string, unknown>[];
    }
  >;
}) => {
  const staleTime = getTimeTillEndOfDayMs();

  const filterOptionsMapped = {
    ...defaultOptionsMapped,
    ...mapFilters(filterOptions, false),
  };
  const enabled = hasUsableScreenerFilters(filterOptionsMapped);

  return {
    queryKey: [QUERY_KEY_SCREENER_ENTITIES, filterOptionsMapped],
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      fetchFilteredEntities(filterOptionsMapped, signal),
    staleTime,
    enabled,
  };
};

export const useScreenerEntities = ({
  filterOptions,
  defaultOptionsMapped,
}: {
  filterOptions: ActiveFilterOptions[];
  defaultOptionsMapped?: Record<
    string,
    {
      values: Record<string, unknown>[];
      children?: Record<string, unknown>[];
    }
  >;
}) => {
  const queryConfig = getScreenerEntitiesQueryConfig({
    filterOptions,
    defaultOptionsMapped,
  });

  return useQuery<FilterResults>(queryConfig);
};
